export default {
    methods: {
        /**
         * format the historical data
         * @param {Array} data3Years
         * @param {Moment} yearStart
         * @return {Array} list of formatted data
         */
        formatHistoricalDateData(data3Years, yearStart) {
            return data3Years.concat(data3Years, data3Years).map((d, i) => {
                const date = yearStart.clone().add(i, 'months');
                return {
                    d: date,
                    v: d.v,
                };
            });
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/formatHistoricalMonthlyDateData.js